import React, { Component } from 'react'
import userManager from '../utils/userManager'

class Login extends Component {
  constructor (props) {
    super(props)
    userManager.signinRedirect({
      data: { path: props.path }
    })
  }

  render () {
    return (
      <span>Loading...</span>
    )
  }
}

export default Login
